import { BusinessType, ContractType, DealType, IMission, JobType, WinType } from '@bloomays-lib/types.shared';

const FREELANCE_TECH_DIGITAL_LABEL = 'Freelance Tech & Digital';
const FREELANCE_BLOOMAYS_PEOPLE_LABEL = 'Freelance Bloomays People';
const CDI_TECH_DIGITAL_LABEL = 'CDI Tech & Digital';
const CDI_BLOOMAYS_PEOPLE_LABEL = 'CDI Bloomays People';

export const getBloomaysLeadOriginLabel = (value: string): string => {
  // Remplace les doubles tirets "--" par un marqueur temporaire
  let formatted = value.replace(/--/g, ' || ');

  // Remplace les tirets restants par des espaces
  formatted = formatted.replace(/-/g, ' ');

  // Supprime les espaces en début et fin de chaîne
  formatted = formatted.trim();

  // Met en majuscule la première lettre de chaque mot
  formatted = formatted.replace(/\b\w/g, (char) => char.toUpperCase());

  // Remplace les marqueurs temporaires par du texte encadré de crochets
  formatted = formatted.replace(/\|\| (.*?)$/g, '[$1]');

  return formatted;
};

export const getDealTypeLabel = (value: DealType): WinType => {
  switch (value) {
    case DealType.CDI_TECH:
      return CDI_TECH_DIGITAL_LABEL;
    case DealType.CDI_PEOPLE:
      return CDI_BLOOMAYS_PEOPLE_LABEL;
    case DealType.IT:
      return FREELANCE_TECH_DIGITAL_LABEL;
    case DealType.RPO:
      return 'Freelance RPO'; // TODO: devrait etre FREELANCE_BLOOMAYS_PEOPLE_LABEL
    case DealType.People:
      return FREELANCE_BLOOMAYS_PEOPLE_LABEL;
  }
};

export const getJobTypeLabel = (value: JobType): string => {
  switch (value) {
    case JobType.Freelance:
    case JobType.Freelance_Tech_Digital:
      return FREELANCE_TECH_DIGITAL_LABEL;
    case JobType.People:
    case JobType.Freelance_Bloomays_People:
    case JobType.Freelance_RPO:
    case JobType.RPO:
      return FREELANCE_BLOOMAYS_PEOPLE_LABEL;
    case JobType.CDI:
    case JobType.CDI_Tech_Digital:
      return CDI_TECH_DIGITAL_LABEL;
    case JobType.CDI_Bloomays_People:
      return CDI_BLOOMAYS_PEOPLE_LABEL;
  }
};

export const getContractType = (value: string): ContractType | undefined => {
  switch (value) {
    case 'Contrat Bloomays ( template Bloomays )':
      return ContractType.bloomaysContract;
    case 'Contrat Client ( template Client )':
      return ContractType.clientContract;
    case 'Devis ( du client si contrat cadre )':
      return ContractType.devis;
    case 'Bon de commande ( du client )':
      return ContractType.BDC;
    default:
      return;
  }
};

export const getContractTypeLabel = (contractType: ContractType): string => {
  switch (contractType) {
    case ContractType.bloomaysContract:
      return 'Contrat Bloomays ( template Bloomays )';
    case ContractType.clientContract:
      return 'Contrat Client ( template Client )';
    case ContractType.devis:
      return 'Devis ( du client si contrat cadre )';
    case ContractType.BDC:
      return 'Bon de commande ( du client )';
  }
};

export const convertDealTypeToBusinessType = (dealType: DealType): BusinessType => {
  switch (dealType) {
    case DealType.CDI_TECH:
    case DealType.IT:
      return BusinessType.IT;
    case DealType.RPO:
    case DealType.CDI_PEOPLE:
    case DealType.People:
      return BusinessType.People;
    default:
      throw new Error(`Unknown deal type ${dealType}`);
  }
};

/** Ligne mission (domaine) ou billing (champ `replacement` seul) pour règle « deal ». */
export const winShouldBeCountAsDeal = (entity: IMission | { replacement?: boolean }) => {
  if ('beginMission' in entity) {
    const m = entity as IMission;
    return !!(!m.replacement && m.shouldBeCountAsDeal);
  }
  return !(entity as { replacement?: boolean }).replacement;
};
